import React, { ComponentType } from 'react';
import {
  CellProps,
  isIntegerControl,
  JsonFormsCellRendererRegistryEntry,
  RankedTester,
  rankWith,
} from '@jsonforms/core';
import { withJsonFormsCellProps } from '@jsonforms/react';
import PlusMinus2 from '../../PlusMinus2/PlusMinus2';
import { RENDERER_RANK_PREFERRED_MATCH } from '../constants';

/**
 * Tester to determine if a control can be used with this cell.
 */
const tester: RankedTester = rankWith(RENDERER_RANK_PREFERRED_MATCH, isIntegerControl);

/**
 * Base cell renderer to show an integer input control.
 * @param props Control props to be hydrated.
 */
const IntegerCellRenderer: ComponentType<CellProps> = (props: CellProps) => {
  return (
    <PlusMinus2
      testID={`IntegerCell-${props.id}`}
      value={
        // start at the current value, or the minimum value, or 0 if no constraints
        props.data ?? props.schema.minimum ?? 0
      }
      min={
        // if no constraint then allow any valid integer
        props.schema.minimum ?? Number.MIN_SAFE_INTEGER
      }
      max={
        // if no constraint then allow any valid integer
        props.schema.maximum ?? Number.MAX_SAFE_INTEGER
      }
      onChange={(newValue: number) => props.handleChange(props.path, newValue)}
    />
  );
};

/**
 * Renderer registry entry for input control.
 * Bundles the tester and the wrapped control for use with form.
 */
export const IntegerCell: JsonFormsCellRendererRegistryEntry = {
  tester,
  cell: withJsonFormsCellProps(IntegerCellRenderer),
};
